import { DetailInfo, DetailRow } from '@labrav/common'
import type { Dimension } from '../../../../modules/privateOffer/reducer'
import { isNonEmptyNumber, numberFormat } from '@labrav/common'
import { get } from 'lodash'
import { useStyles } from './AdditionalUsageAndSubscriptionDimensions.styles'

type DimensionPriceKey = {
  keyName: string
  label: string
}

type AdditionalUsageAndSubscriptionDimensionsProps = {
  dimensions?: Dimension[]
  keyName?: string
  priceArray?: DimensionPriceKey[]
  currencySymbol?: string
}

export const AdditionalUsageAndSubscriptionDimensions = ({
  dimensions,
  priceArray = [],
  currencySymbol,
}: AdditionalUsageAndSubscriptionDimensionsProps) => {
  const { classes } = useStyles()

  const dimensionsList = (dimensions || []).map((dimension, index) => (
    <DetailRow
      borderBottom={index + 1 !== (dimensions || []).length}
      children={
        <>
          <DetailInfo
            varient="small"
            gridSize={3}
            value={dimension?.label ? dimension?.label : '-'}
            keyName="dimension-label"
          />
          {priceArray?.map(priceItem => (
            <DetailInfo
              varient="small"
              gridSize={3}
              keyName="dimension-price"
              value={
                <div className={classes.price}>
                  {isNonEmptyNumber(
                    get(dimension, priceItem?.keyName) as number
                  ) ? (
                    <>
                      <span className={classes.currency}>{currencySymbol}</span>
                      {numberFormat(
                        get(dimension, priceItem?.keyName) as number,
                        3
                      )}
                    </>
                  ) : (
                    '-'
                  )}
                </div>
              }
            />
          ))}
        </>
      }
    />
  ))
  return (
    <div className={classes.root} data-testid={'additional-usage-dimesnions'}>
      <DetailRow
        borderBottom
        children={
          <>
            <DetailInfo gridSize={3} title="Dimension" />
            {priceArray?.map(priceItem => (
              <DetailInfo
                gridSize={3}
                title={
                  <div className={classes.titleRight}>{priceItem?.label}</div>
                }
              />
            ))}
          </>
        }
      />
      {dimensionsList}
    </div>
  )
}
